import cx from "classnames";
import { FunctionComponent, useEffect, useRef, useState } from "react";
import { Color } from "./Types";

type DieProps = {
  dieValue: number;
  dieSpent: boolean;
  color: Color;
  forceReroll: boolean;
};

const Die: FunctionComponent<DieProps> = ({ dieValue, dieSpent, color, forceReroll }) => {
  const [rolling, setRolling] = useState(false);
  const prevReroll = useRef(forceReroll);

  useEffect(() => {
    if (prevReroll.current && !forceReroll) {
      setRolling(true);
      const t = setTimeout(() => setRolling(false), 700);
      return () => clearTimeout(t);
    }
    prevReroll.current = forceReroll;
  }, [forceReroll]);

  return (
    /* Die-wrapper получает bounce-анимацию.
       Die-faces отвечает ТОЛЬКО за 3D-вращение к нужной грани.
       Разделение критично: animation на том же элементе,
       что и transition:transform, перезаписывает 3D-ротацию → артефакты. */
    <div className={cx("Die-wrapper", { rolling })}>
      <div
        className={cx("Die-faces", {
          white:  color === Color.White,
          black:  color === Color.Black,
          reroll: forceReroll,
          one:   dieValue === 1,
          two:   dieValue === 2,
          three: dieValue === 3,
          four:  dieValue === 4,
          five:  dieValue === 5,
          six:   dieValue === 6,
          spent: dieSpent,
        })}
      >
        <div className={cx("Die-face", "one")}>   <div className={cx("Die-pip", "five")} /> </div>
        <div className={cx("Die-face", "two")}>   <div className={cx("Die-pip", "three")} /> <div className={cx("Die-pip", "seven")} /> </div>
        <div className={cx("Die-face", "three")}> <div className={cx("Die-pip", "three")} /> <div className={cx("Die-pip", "five")} />  <div className={cx("Die-pip", "seven")} /> </div>
        <div className={cx("Die-face", "four")}>  <div className={cx("Die-pip", "one")} />   <div className={cx("Die-pip", "three")} /> <div className={cx("Die-pip", "seven")} /> <div className={cx("Die-pip", "nine")} /> </div>
        <div className={cx("Die-face", "five")}>  <div className={cx("Die-pip", "one")} />   <div className={cx("Die-pip", "three")} /> <div className={cx("Die-pip", "five")} />  <div className={cx("Die-pip", "seven")} /> <div className={cx("Die-pip", "nine")} /> </div>
        <div className={cx("Die-face", "six")}>   <div className={cx("Die-pip", "one")} />   <div className={cx("Die-pip", "three")} /> <div className={cx("Die-pip", "four")} />  <div className={cx("Die-pip", "six")} />   <div className={cx("Die-pip", "seven")} /> <div className={cx("Die-pip", "nine")} /> </div>
      </div>
    </div>
  );
};

export default Die;
